export const USER_ROLES = {
    S_ADMIN: "S_ADMIN",
    TRUSTEE: "TRUSTEE",
    VOLUNTEER: "VOLUNTEER"
}